<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(document).ready(function () {
  function initializeSlider() {
    const element = $('.custom-category-slider-mobile');
    if ($(window).width() <= 768) { // Target mobile screens
      if (element.not('.slick-initialized').length) { 
        element.slick({
          slidesToShow: 4,
          infinite: false,
          slidesToScroll: 1,
          arrows: false,
          responsive: [
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 391, // Smaller tablets & large phones
              settings: {
                slidesToShow: 2.5
              }
            }
          ]
        });
      }
    } else {
      if (element.hasClass('slick-initialized')) {
        element.slick('unslick'); // Destroy slider on larger screens
      }
    }
  }

  // Initialize on page load
  initializeSlider();

  // Re-check on window resize
  $(window).resize(function () {
    initializeSlider();
  });
});
window.addEventListener('option:changed', function(e) {
    var option = e.detail;
    // console.log('Option changed:', option);
    setTimeout(() => {
        var priceElement = document.querySelector('.price__regular .price-item');
        var price = priceElement ? parseFloat(priceElement.getAttribute('data-live-format').replace(/[^0-9.]/g, '')) : null;

        var quantityInput = document.querySelector('.quantity__container .quantity__input');
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) : null;

        if (price !== null && quantity !== null) {
            var totalPrice = (price * quantity).toFixed(2);
            var cartPriceSpan = document.querySelector('#product-add-to-cart .data_live_price');
            if (cartPriceSpan) {
                cartPriceSpan.setAttribute('data-live-format', `$${totalPrice}`);
                cartPriceSpan.textContent = `$${totalPrice}`;
            }
        }
    }, 200); 
});
